import apiClient from './api';
import { toSearchParams } from './callsApi';

// Insights (docs/design/contracts.md §7, A013). Every call takes the global filter params (hierarchyNodeIds,
// communityIds, from, to) plus its own options.
const get = async (path, params) => {
  const response = await apiClient.get(`${path}?${toSearchParams(params).toString()}`);
  return response.data;
};

export const insightsApi = {
  overview: (params) => get('/insights/overview', params),
  concerns: (params) => get('/insights/concerns', params),
  sentimentTrend: (params) => get('/insights/sentiment-trend', params),
  repeatCallers: (params) => get('/insights/repeat-callers', params),
  escalations: (params) => get('/insights/escalations', params),
  markReviewed: async (id) => {
    const response = await apiClient.post(`/insights/calls/${encodeURIComponent(id)}/review`);
    return response.data;
  },
};

export default insightsApi;
